module.exports = __webpack_public_path__ + "static/media/0028.2874a86c.jpg";